module.exports = cfp.vendors["react-dom@18"];